import { ImgProps } from "./types";

export default function ImgJacqueMobile(props: ImgProps) {
	const { height = "240", width = "765" } = props;
	return (
		<img
			src="/assets/images/img-jacque-mobile.webp"
			alt="Jacque Menassa"
			loading="eager"
			width={width}
			height={height}
		/>
	);
}
